module.exports = __webpack_public_path__ + "static/img/xq-2.451b75a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xq-2.png
// module id = PDSJ
// module chunks = 1